import React, { FC } from 'react';
import { Typography } from '@mui/material';
import { ScanType, currentScanTypes } from '@services';
import styles from './ScanTypesComponent.module.scss';
import ScanTypeComponent from '../ScanTypeComponent/ScanTypeComponent';

interface ScanTypesComponentProps {
    scanTypes: ScanType[];
    showMissing?: boolean;
}

const ScanTypesComponent: FC<ScanTypesComponentProps> = ({ scanTypes, showMissing }) => (
    <div className={styles.ScanTypesComponent} data-testid="ScanTypesComponent">
        {showMissing ? currentScanTypes.map((t) => (
            <Typography component="span" key={t} sx={{ ml: 1 }}>
                <ScanTypeComponent
                    scanType={t as ScanType}
                    color={scanTypes.includes(t as ScanType) ? 'primary' : 'grey100.main'}
                />
            </Typography>
        )) : currentScanTypes.reduce((a, c) => {
            if (scanTypes.includes(c as ScanType)) {
                a.push(
                    <Typography component="span" key={c} sx={{ ml: 0.5 }}>
                        <ScanTypeComponent
                            scanType={c as ScanType}
                        />
                    </Typography>,
                );
            }
            return a;
        }, [] as React.ReactNode[])}
    </div>
);

export default ScanTypesComponent;

ScanTypesComponent.defaultProps = {
    showMissing: false,
};
